import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { Modal } from 'react-bootstrap';
import { modalDidMount, modalWillUnmount } from './ModalFixMixin';

require.ensure([], () => {
    require('./NewTaskWidget.less');
});

class NewTaskWidget extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            name: ""
        };
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        modalDidMount();
        ReactDOM.findDOMNode(this.refs.nameInput).focus();
    }

    componentWillUnmount = () => {
        modalWillUnmount();
    }

    // EVENT HANDLERS

    handleClose = () => {
        this.props.handleClose();
    }

    handleKeyPress = (keyEvent) => {
        if (keyEvent.key === "Enter") {
            this.handleSave();
        }

        keyEvent.stopPropagation();
    }

    handleKeyUp = (keyEvent) => {
        if (keyEvent.key === "Escape") {
            this.handleClose();
        }

        keyEvent.stopPropagation();
    }

    handleNameChange = (event) => {
        let name = event.target.value.trim();

        this.setState({
            name: event.target.value,
            nameError: name === '' || this._taskExists(name) ? true : false
        });
    }

    handleRefocus = () => {
        ReactDOM.findDOMNode(this.refs.nameInput).focus();
    }

    handleSave = () => {
        let task = {
            name: this.state.name.trim(),
            closed: false,
            parent: this.props.parent
        };

        this.validate();

        if (!this.state.nameError) {
            this.props.handleSave(task);
            this.props.handleClose();
        }
    }

    // OTHER METHODS

    _taskExists = (name) => {
        let searchElement = name.trim().replace(/\s\s+/g, ' ').toLowerCase();
        for (let i = 0; i < this.props.taskNames.length; i++) {
            let existingTaskName = this.props.taskNames[i].trim().replace(/\s\s+/g, ' ').toLowerCase();
            if (existingTaskName === searchElement) {
                return true;
            }
        }

        return false;
    }

    validate = () => {
        this.state.nameError = this.state.name.trim() === '' || this._taskExists(this.state.name);
        this.forceUpdate();
    }

    // RENDER METHOD

    render = () => {
        return (
            <Modal show={true} onKeyUp={this.handleKeyUp} onKeyPress={this.handleKeyPress} className="modal fade" id="myModal4" tabIndex="-1" role="dialog" aria-labelledby="myModal4Label" aria-hidden="true">
                <div className="modal-dialog new-log-entry" >
                    <div className="modal-content">
                        <div className="modal-header">
                            <button style={{marginTop : "-20px", marginRight : "-5px"}} onClick={this.handleClose} type="button" className="close" data-dismiss="modal" aria-label="Close">
                               <span aria-hidden="true">×</span>
                            </button>
                            <h4 className="modal-title" id="myModalLabel">New Project Task</h4>
                        </div>
                        <div className="modal-body">
                            <span className={this.state.nameError ? "has-error" : null}>
                                <input ref="nameInput" type="text" className="form-control" value={this.state.name} onChange={this.handleNameChange} placeholder="Task Name"/>
                            </span>
                        </div>
                        <div className="modal-footer">
                            <button title="Create task" ref="createButton" type="button" className="btn btn-default btn-large" onClick={this.handleSave}>Create</button>
                            <button title="Cancel and close dialog" onBlur={this.handleRefocus} ref="closeButton" type="button" className="btn btn-default btn-discrete" onClick={this.handleClose}>Close</button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

NewTaskWidget.propTypes = {
    handleClose: PropTypes.func,
    handleSave: PropTypes.func,
    parentID: PropTypes.number,
    taskNames: PropTypes.array
};

export default connect()(NewTaskWidget);



/** WEBPACK FOOTER **
 ** ./src/app/components/NewTaskWidget.js
 **/